import React, { useState, useEffect } from 'react';
import styles from './ScrimSettings.module.css';

interface ScrimSettingsProps {
  isOpen: boolean;
  onClose: () => void;
  liveEdgeSafetyBuffer: number;
  onSave: (value: number) => void;
}

const ScrimSettings: React.FC<ScrimSettingsProps> = ({
  isOpen,
  onClose,
  liveEdgeSafetyBuffer,
  onSave
}) => {
  const [inputValue, setInputValue] = useState<string>('');

  // Initialize input value when modal opens
  useEffect(() => {
    if (isOpen) {
      setInputValue(liveEdgeSafetyBuffer.toString());
    }
  }, [isOpen, liveEdgeSafetyBuffer]);

  if (!isOpen) return null;

  const handleSave = () => {
    const numValue = Number(inputValue);
    // Validate: must be a number between -500 and 500
    if (!isNaN(numValue) && numValue >= -500 && numValue <= 500) {
      onSave(numValue);
      onClose();
    }
  };

  const handleClose = () => {
    // Reset to original value when closing without saving
    setInputValue(liveEdgeSafetyBuffer.toString());
    onClose();
  };

  const numValue = Number(inputValue);
  const isValid = !isNaN(numValue) && numValue >= -500 && numValue <= 500;

  return (
    <div className={styles.modal} onClick={handleClose}>
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <h3>Settings</h3>
        
        <div className={styles.settingGroup}>
          <label htmlFor="liveEdgeBuffer" className={styles.settingLabel}>
            Youtube Live Safety Buffer
          </label>
          <input
            id="liveEdgeBuffer"
            type="number"
            className={styles.settingInput}
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            min="-500"
            max="500"
            placeholder="30"
          />
          <div className={styles.settingDescription}>
            Buffer in seconds to prevent seeking too close to live edge.
          </div>
          <div className={styles.tipsBox}>
            <div><strong>Decrease</strong> if you're lagging behind the live stream.</div>
            <div><strong>Increase</strong> if playback struggles near the live edge.</div>
          </div>
          {inputValue !== '' && !isValid && (
            <div className={styles.errorMessage}>
              Value must be a number between -500 and 500
            </div>
          )}
        </div>

        <div className={styles.modalActions}>
          <button 
            className={styles.closeButton}
            onClick={handleClose}
          >
            Close
          </button>
          <button 
            className={styles.saveButton}
            onClick={handleSave}
            disabled={!isValid}
          >
            Apply
          </button>
        </div>
      </div>
    </div>
  );
};

export default ScrimSettings;

